export const PUSH_PROMPT_STORAGE_KEY = "ovo_pushPromptDismissedAt";

/** 10 days — inside the 7–14 day cooldown window. */
export const PUSH_PROMPT_COOLDOWN_MS = 10 * 24 * 60 * 60 * 1000;

export function markPushPromptDismissed() {
  try {
    localStorage.setItem(PUSH_PROMPT_STORAGE_KEY, String(Date.now()));
  } catch {
    /* ignore quota / private mode */
  }
}

/**
 * Show the in-app permission bar only when:
 * - the browser permission is still "default"
 * - Settings → "Remind me to enable notifications" is on (default)
 * - the last dismiss is older than the cooldown (or never dismissed)
 */
export function shouldShowPushPrompt({ permission, remindEnabled } = {}) {
  if (permission !== "default") return false;
  if (remindEnabled === false) return false;
  try {
    const at = Number(localStorage.getItem(PUSH_PROMPT_STORAGE_KEY) || 0);
    if (at && Date.now() - at < PUSH_PROMPT_COOLDOWN_MS) return false;
  } catch {
    return true;
  }
  return true;
}
